import { apiClient } from "./client";

// Platform API tokens (ADR-015). These endpoints are hand-written HTTP
// handlers (not proto), so keys are snake_case. Session-only: a token can
// never manage tokens.

export interface ApiToken {
  id: string;
  name: string;
  scopes: string[];
  org_ids: string[];
  include_children: boolean;
  expires_at: string;
  created_at: string;
  last_used_at: string | null;
  revoked_at: string | null;
}

export interface CreateTokenRequest {
  name: string;
  scopes: string[];
  org_ids?: string[];
  include_children?: boolean;
  expires_in_days?: number;
}

export interface CreateTokenResponse {
  success: boolean;
  message: string;
  token: string; // plaintext, shown once
  token_info: ApiToken;
}

export interface TokenScopesResponse {
  scopes: Record<string, string>;
  default_ttl_days: number;
  max_ttl_days: number;
}

export async function listApiTokens(): Promise<ApiToken[]> {
  const { data } = await apiClient.get<{ tokens: ApiToken[] }>("/tokens");
  return data.tokens;
}

export async function createApiToken(req: CreateTokenRequest): Promise<CreateTokenResponse> {
  const { data } = await apiClient.post<CreateTokenResponse>("/tokens", req);
  return data;
}

export async function revokeApiToken(id: string): Promise<void> {
  await apiClient.delete(`/tokens/${id}`);
}

export async function getTokenScopes(): Promise<TokenScopesResponse> {
  const { data } = await apiClient.get<TokenScopesResponse>("/tokens/scopes");
  return data;
}
